import type {
    EmailObject as Email,
    Address as GeneratedAddress,
    Contact as GeneratedContact,
    Phone,
    WebApiError,
} from '@api-client/contacts';
import type { SignInfo } from '@shared/core-types';

export type { Email, Phone };

export interface Address extends GeneratedAddress {
    postBox?: string;
    'hu-streetType'?: string;
    'hu-buildingName'?: string;
    'hu-stair'?: string;
    'hu-floor'?: string;
    'hu-apartment'?: string;
    streetType?: string;
    buildingName?: string;
    stair?: string;
    floor?: string;
    apartment?: string;
    county?: string;
}

export type ContactType = GeneratedContact['type'];
export const ContactType = {
    ADDRESS: 'ADDRESS',
    PHONE: 'PHONE',
    EMAIL: 'EMAIL',
} as const;

export const ADDRESS_PO_BOX_CONTACT_TYPE = `${ContactType.ADDRESS}-POBOX`;

export enum AddressType {
    NORMAL = 'normal',
    PO_BOX = 'poBox',
}

export enum ContactListFlag {
    ADDRESS_NOT_ALLOWED = 'addressEntryNotAllowed',
    TOO_MANY_ADDRESSES = 'skTooManyAddresses',
    PHONE_NOT_ALLOWED = 'phoneEntryNotAllowed',
    EMAIL_NOT_ALLOWED = 'emailEntryNotAllowed',
    MOBILE_PHONE_NOT_ALLOWED = 'mobilePhoneEntryNotAllowed', // subset of PHONE
    LANDLINE_PHONE_NOT_ALLOWED = 'landlinePhoneEntryNotAllowed', // subset of PHONE,
}

export enum ContactFlag {
    DELETABLE = 'deletable',
    EDITABLE = 'editable',
    MAIN_CONTACT = 'mainContact',
    INVALID = 'invalidContact',
    PERMANENT_ADDRESS = 'permanentResidenceAddress',
    MOBILE_PHONE_NUMBER = 'mobilePhoneNumber',
    MASKED_PHONE_NUMBER = 'maskedPhoneNumber',
    UNDEFINED_CONTACT = 'undefinedContact',
    CONFIRMATION_REQUIRED = 'confirmationRequired',
    VERIFICATION_REQUIRED = 'verificationRequired',
    MANDATORY_VERIFICATION_REQUIRED = 'mandatoryVerificationRequired',
}

export interface BusinessContactDetails {
    id: string;
    fullName: string;
}

export interface Contact extends Omit<GeneratedContact, 'signInfo' | 'flags'> {
    signInfo?: SignInfo;
    flags?: ContactFlag[];
}

export type ApiError = WebApiError;

export enum CDMError {
    ID_NOT_FOUND = 'ID_NOT_FOUND',
    CONTACT_NOT_DELETABLE = 'CONTACT_NOT_DELETABLE',
    AT_ADDRESS_USED_FOR_ACCOUNT = 'ADDRESS_USED_FOR_ACCOUNT',
}

export interface BusinessContactDetailsWithContacts extends BusinessContactDetails {
    contacts: Contact[];
}
